module.exports = __webpack_public_path__ + "static/media/balance-scale.89d379d5.svg";